import React from 'react';
import PropTypes from 'prop-types';

import './Alarms.css';


const Alarms = ({ primaryName, alarmsVideo, alarmsPrimary, focusedPrimaryId }) => {
  const hasAlerts = (alarmsVideo && alarmsVideo.length > 0) || (alarmsPrimary && alarmsPrimary.length > 0);

  return (
    <div className="alarms-wrapper">
      <div className="premium-header">
        <div className="analytics-title">
          <i className="material-icons" style={{ color: '#f39c12' }}>warning</i>
          <span>ALERTS ANALYTICS</span>
        </div>
      </div>

      <div className="alarms-body scrollbar-hidden">
        {hasAlerts ? (
          <ul className="alerts-list">
            {alarmsVideo && alarmsVideo.map(({ name, type, message }) => (
              <li key={name} className="alert-card">
                <i className={`material-icons alert-icon text-${type === 'ERROR' ? 'danger' : 'warning'}`}>
                  {type === 'ERROR' ? 'error' : 'warning'}
                </i>
                <span className="alert-message">{message}</span>
              </li>
            ))}

            {alarmsPrimary && alarmsPrimary.map(({ name, type, message }) => (
              <li key={name} className="alert-card">
                <i className={`material-icons alert-icon text-${type === 'ALARM' ? 'danger' : 'warning'}`}>
                  {type === 'ALARM' ? 'error' : 'warning'}
                </i>
                <span className="alert-message">{message}</span>
              </li>
            ))}
          </ul>
        ) : (
          <div className="empty-alerts">
            <i className="material-icons">notifications_none</i>
            <span>{focusedPrimaryId ? 'No active alerts' : 'No primary selected'}</span>
          </div>
        )}
      </div>
    </div>
  );
};

Alarms.propTypes = {
  primaryName: PropTypes.string.isRequired,
  alarmsVideo: PropTypes.array,
  alarmsPrimary: PropTypes.array,
  focusedPrimaryId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default React.memo(Alarms);
